import { DefineComponentProps, safeSecondToMillisecond } from 'utils'
import { PositionItemLayout } from '../layouts/PositionInfo.layout'
import { useExchangeInfoStore, useUserCenterContractOrderStore } from 'store'
import classNames from 'classnames'
import { dayjs } from 'element-plus'
import { ListCell } from '..'
import { useI18n } from 'i18n-utils'

interface FundFlowItemProps {
  data: ApiResponse.FundFlow
  divider?: boolean
}

export const FundFlowItem = defineComponent<FundFlowItemProps>({
  props: DefineComponentProps<FundFlowItemProps>(['data', 'divider']),
  setup(props) {
    const contractOrderListStore = useUserCenterContractOrderStore()
    const { t } = useI18n()
    const exchangeStore = useExchangeInfoStore()

    const isRenderContractName = computed(() => {
      const row = props.data
      const config = exchangeStore.getContractSymbolInfoBySymbolId(row.symbolId)
      return row.originType !== 10003 && row.originType !== 10004 && config?.symbolName
    })

    const contractName = computed(() => {
      const row = props.data
      return `${exchangeStore.getContractSymbolName(row.symbolId)} ${t('永续')}`
    })

    return () => {
      return (
        <PositionItemLayout class={classNames('position-item', { divider: props.divider })}>
          <div class="symbol-coin-info">
            <img width={24} src={contractOrderListStore.getSettleItemIcon(props.data.symbolId)} alt="" />
            <div class="coin-info">
              <div class="coin-name">{contractOrderListStore.getSettleItemName(props.data.symbolId)}</div>
            </div>
            <div class="date-time">{dayjs(safeSecondToMillisecond(props.data.createTime)).format('YYYY-MM-DD HH:mm:ss')}</div>
          </div>

          <div class="position-info">
            <ListCell title={t('类型')} description={contractOrderListStore.getFundFlowType(props.data)} />
            {isRenderContractName.value && <ListCell title={t('合约')} description={contractName.value} />}
            <ListCell title={t('总额')} description={props.data.delta.formatNumberWithCommas()} />
          </div>
        </PositionItemLayout>
      )
    }
  },
})
